export const state = () => ({
    list: {
        man: null,
        woman: null,
    },
    categories: {
        man: null,
        woman: null,
    },
    drops: [],
    keyedDrops: {},
});

export const mutations = {
    change(state, data) {
        state.list[data.gender] = data.list;
    },
    changeCategories(state, data) {
        state.categories[data.gender] = data.list;
    },
    changeDrops(state, data) {
        state.drops = data;
        data.forEach((d) => {
            state.keyedDrops[d.slug] = d;
        });
    },
};

export const getters = {
    get(state) {
        return state.list;
    },
    getCategories(state) {
        return state.categories;
    },
    getMenuHeight(state) {
        let maxLength = 0;
        if (state.categories) {
            maxLength = Math.round(state.categories.length / 2);
        }
        return maxLength * 33;
    },
};

export const actions = {
    async init({ commit }) {
        try {
            const requests = [
                this.$axios.$get("/api/collections/list?gender=man"),
                this.$axios.$get("/api/collections/list?gender=woman"),
                this.$axios.$get("/api/categories?gender=man"),
                this.$axios.$get("/api/categories?gender=woman"),
                this.$axios.$get(`/api/drops`),
            ];
            const [collectionsman, collectionswoman, categoriesman, categorieswoman, drops] = await Promise.all(
                requests
            );

            const dropsInfo = [];
            if (drops.length) {
                const dropsData = await Promise.all(drops.map((d) => this.$axios.$get(`/api/drops/${d.slug}`)));
                dropsData.forEach((dd) => {
                    if (dd.skus.length) {
                        dropsInfo.push(dd);
                    }
                });
            }

            commit("change", {
                gender: "man",
                list: collectionsman,
            });
            commit("change", {
                gender: "woman",
                list: collectionswoman,
            });
            commit("changeCategories", {
                gender: "man",
                list: categoriesman,
            });
            commit("changeCategories", {
                gender: "woman",
                list: categorieswoman,
            });
            if (dropsInfo.length) {
                commit("changeDrops", dropsInfo);
            }
        } catch (error) {
            console.log(`error =>`, error);
        }
    },
};
